class ZrpCountrySwitcher {
    
    /**
     * Country codes
     */
    codes = {
        "AF": "Afghanistan",
        "AX": "Åland Islands",
        "AL": "Albania",
        "DZ": "Algeria",
        "AS": "American Samoa",
        "AD": "Andorra",
        "AO": "Angola",
        "AI": "Anguilla",
        "AQ": "Antarctica",
        "AG": "Antigua and Barbuda",
        "AR": "Argentina",
        "AM": "Armenia",
        "AW": "Aruba",
        "AU": "Australia",
        "AT": "Austria",
        "AZ": "Azerbaijan",
        "BS": "Bahamas",
        "BH": "Bahrain",
        "BD": "Bangladesh",
        "BB": "Barbados",
        "BY": "Belarus",
        "BE": "Belgium",
        "BZ": "Belize",
        "BJ": "Benin",
        "BM": "Bermuda",
        "BT": "Bhutan",
        "BO": "Bolivia",
        "BQ": "Bonaire, Sint Eustatius and Saba",
        "BA": "Bosnia and Herzegovina",
        "BW": "Botswana",
        "BV": "Bouvet Island",
        "BR": "Brazil",
        "IO": "British Indian Ocean Territory",
        "BN": "Brunei Darussalam",
        "BG": "Bulgaria",
        "BF": "Burkina Faso",
        "BI": "Burundi",
        "CV": "Cabo Verde",
        "KH": "Cambodia",
        "CM": "Cameroon",
        "CA": "Canada",
        "KY": "Cayman Islands",
        "CF": "Central African Republic",
        "TD": "Chad",
        "CL": "Chile",
        "CN": "China",
        "CX": "Christmas Island",
        "CC": "Cocos (Keeling) Islands",
        "CO": "Colombia",
        "KM": "Comoros",
        "CG": "Congo",
        "CD": "Congo (Democratic Republic of the)",
        "CK": "Cook Islands",
        "CR": "Costa Rica",
        "CI": "Côte d'Ivoire",
        "HR": "Croatia",
        "CU": "Cuba",
        "CW": "Curaçao",
        "CY": "Cyprus",
        "CZ": "Czechia",
        "DK": "Denmark",
        "DJ": "Djibouti",
        "DM": "Dominica",
        "DO": "Dominican Republic",
        "EC": "Ecuador",
        "EG": "Egypt",
        "SV": "El Salvador",
        "GQ": "Equatorial Guinea",
        "ER": "Eritrea",
        "EE": "Estonia",
        "SZ": "Eswatini",
        "ET": "Ethiopia",
        "FK": "Falkland Islands",
        "FO": "Faroe Islands",
        "FJ": "Fiji",
        "FI": "Finland",
        "FR": "France",
        "GF": "French Guiana",
        "PF": "French Polynesia",
        "TF": "French Southern Territories",
        "GA": "Gabon",
        "GM": "Gambia",
        "GE": "Georgia",
        "DE": "Germany",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GR": "Greece",
        "GL": "Greenland",
        "GD": "Grenada",
        "GP": "Guadeloupe",
        "GU": "Guam",
        "GT": "Guatemala",
        "GG": "Guernsey",
        "GN": "Guinea",
        "GW": "Guinea-Bissau",
        "GY": "Guyana",
        "HT": "Haiti",
        "HM": "Heard Island and McDonald Islands",
        "VA": "Holy See",
        "HN": "Honduras",
        "HK": "Hong Kong",
        "HU": "Hungary",
        "IS": "Iceland",
        "IN": "India",
        "ID": "Indonesia",
        "IR": "Iran",
        "IQ": "Iraq",
        "IE": "Ireland",
        "IM": "Isle of Man",
        "IL": "Israel",
        "IT": "Italy",
        "JM": "Jamaica",
        "JP": "Japan",
        "JE": "Jersey",
        "JO": "Jordan",
        "KZ": "Kazakhstan",
        "KE": "Kenya",
        "KI": "Kiribati",
        "KP": "North Korea",
        "KR": "South Korea",
        "KW": "Kuwait",
        "KG": "Kyrgyzstan",
        "LA": "Laos",
        "LV": "Latvia",
        "LB": "Lebanon",
        "LS": "Lesotho",
        "LR": "Liberia",
        "LY": "Libya",
        "LI": "Liechtenstein",
        "LT": "Lithuania",
        "LU": "Luxembourg",
        "MO": "Macao",
        "MG": "Madagascar",
        "MW": "Malawi",
        "MY": "Malaysia",
        "MV": "Maldives",
        "ML": "Mali",
        "MT": "Malta",
        "MH": "Marshall Islands",
        "MQ": "Martinique",
        "MR": "Mauritania",
        "MU": "Mauritius",
        "YT": "Mayotte",
        "MX": "Mexico",
        "FM": "Micronesia",
        "MD": "Moldova",
        "MC": "Monaco",
        "MN": "Mongolia",
        "ME": "Montenegro",
        "MS": "Montserrat",
        "MA": "Morocco",
        "MZ": "Mozambique",
        "MM": "Myanmar",
        "NA": "Namibia",
        "NR": "Nauru",
        "NP": "Nepal",
        "NL": "Netherlands",
        "NC": "New Caledonia",
        "NZ": "New Zealand",
        "NI": "Nicaragua",
        "NE": "Niger",
        "NG": "Nigeria",
        "NU": "Niue",
        "NF": "Norfolk Island",
        "MK": "North Macedonia",
        "MP": "Northern Mariana Islands",
        "NO": "Norway",
        "OM": "Oman",
        "PK": "Pakistan",
        "PW": "Palau",
        "PS": "Palestine, State of",
        "PA": "Panama",
        "PG": "Papua New Guinea",
        "PY": "Paraguay",
        "PE": "Peru",
        "PH": "Philippines",
        "PN": "Pitcairn",
        "PL": "Poland",
        "PT": "Portugal",
        "PR": "Puerto Rico",
        "QA": "Qatar",
        "RE": "Réunion",
        "RO": "Romania",
        "RU": "Russia",
        "RW": "Rwanda",
        "BL": "Saint Barthélemy",
        "SH": "Saint Helena, Ascension and Tristan da Cunha",
        "KN": "Saint Kitts and Nevis",
        "LC": "Saint Lucia",
        "MF": "Saint Martin (French part)",
        "PM": "Saint Pierre and Miquelon",
        "VC": "Saint Vincent and the Grenadines",
        "WS": "Samoa",
        "SM": "San Marino",
        "ST": "Sao Tome and Principe",
        "SA": "Saudi Arabia",
        "SN": "Senegal",
        "RS": "Serbia",
        "SC": "Seychelles",
        "SL": "Sierra Leone",
        "SG": "Singapore",
        "SX": "Sint Maarten (Dutch part)",
        "SK": "Slovakia",
        "SI": "Slovenia",
        "SB": "Solomon Islands",
        "SO": "Somalia",
        "ZA": "South Africa",
        "GS": "South Georgia and the South Sandwich Islands",
        "SS": "South Sudan",
        "ES": "Spain",
        "LK": "Sri Lanka",
        "SD": "Sudan",
        "SR": "Suriname",
        "SJ": "Svalbard and Jan Mayen",
        "SE": "Sweden",
        "CH": "Switzerland",
        "SY": "Syria",
        "TW": "Taiwan",
        "TJ": "Tajikistan",
        "TZ": "Tanzania",
        "TH": "Thailand",
        "TL": "Timor-Leste",
        "TG": "Togo",
        "TK": "Tokelau",
        "TO": "Tonga",
        "TT": "Trinidad and Tobago",
        "TN": "Tunisia",
        "TR": "Turkey",
        "TM": "Turkmenistan",
        "TC": "Turks and Caicos Islands",
        "TV": "Tuvalu",
        "UG": "Uganda",
        "UA": "Ukraine",
        "AE": "United Arab Emirates",
        "GB": "United Kingdom",
        "US": "United States",
        "UM": "United States Minor Outlying Islands",
        "UY": "Uruguay",
        "UZ": "Uzbekistan",
        "VU": "Vanuatu",
        "VE": "Venezuela",
        "VN": "Viet Nam",
        "VG": "Virgin Islands (British)",
        "VI": "Virgin Islands (U.S.)",
        "WF": "Wallis and Futuna",
        "EH": "Western Sahara",
        "YE": "Yemen",
        "ZM": "Zambia",
        "ZW": "Zimbabwe"
    }

    /**
     * Settings from attribute
     */
    settings = {
        hintMsg: '',
        title: '',
        url: '',
        hint: {
            ok: '',
            desc: '',
            title: '',
            cancel: '',
        }
    };

    /**
     * Session storage
     */
    storage = {};


    /**
     * Root node
     */
    elParent = null;

    constructor() {
        this.elParent = document.querySelector('.zrp-c-switcher');

        if (this.elParent) {
            this.settings = JSON.parse(this.elParent.dataset.settings);
        }

        this.storage = this.getStorage();
    }

    /**
     * Init view
     */
    init() {
        if (this.elParent) {
            
            const { title, url, hintMsg, hint } = this.settings;
            const { country } = this.storage;
            
            if (country) {

                // Title
                const titleEl = this.createEl('h3', title, 'zrp-c-switcher__title');
                // Switcher inner
                const switcherInnerEl = this.createEl('button', null, 'zrp-c-switcher__inner', [{'name': 'type', 'value': 'button'}]);
                // Flag el
                const flagEl = this.createEl('span', null, ['fi', `fi-${country.toLowerCase()}`]);
                // Text el
                const flagTextEl = this.createEl('span', this.codes[country], 'zrp-c-switcher__flag-name');
                // Hint
                const hintMsgEl = this.createEl('a', hintMsg, ['zrp-c-switcher__hint-msg'], [{'name': 'href', 'value': '#'}]);

                const showPanel = () => {
                    const panelEl = this.elParent.querySelector('.zrp-c-switcher__hp');

                    if (panelEl) {
                        panelEl.classList.remove('zrp-c-switcher--hide');
                    }
                }

                const hidePanel = () => {
                    const panelEl = this.elParent.querySelector('.zrp-c-switcher__hp');

                    if (panelEl) {
                        panelEl.classList.add('zrp-c-switcher--hide');
                    }
                }

                switcherInnerEl.onclick = (e) => {
                    e.preventDefault();
                    showPanel();
                };

                switcherInnerEl.appendChild(flagEl);
                switcherInnerEl.appendChild(flagTextEl);
                switcherInnerEl.appendChild(hintMsgEl);

                hintMsgEl.onclick = (e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    showPanel();
                };

                // Panel message
                const panelHintEl = this.createEl('div', null, ['zrp-c-switcher__hp', 'zrp-c-switcher--hide']);
                // Panel hint title
                const panelHintTitleEl = this.createEl('h4', hint.title, 'zrp-c-switcher__hp-title');
                // Panel hint desc
                const panelHintDescEl = this.createEl('p', hint.desc, 'zrp-c-switcher__hp-desc');
                // Panel hint continue button
                const panelHintOkEl = this.createEl('button', hint.ok, 'zrp-c-switcher__hp-btn', [{'name': 'type', 'value': 'button'}]);
                // Panel hint cancel button
                const panelHintCancelEl = this.createEl('button', hint.cancel, ['zrp-c-switcher__hp-btn', 'zrp-c-switcher__hp-btn--cancel'], [{'name': 'type', 'value': 'button'}]);

                panelHintOkEl.onclick = (e) => {
                    e.preventDefault();
                    window.location.href = url;
                };

                panelHintCancelEl.onclick = (e) => {
                    e.preventDefault();
                    hidePanel();
                };

                panelHintEl.appendChild(panelHintTitleEl);
                panelHintEl.appendChild(panelHintDescEl);
                panelHintEl.appendChild(panelHintOkEl);
                panelHintEl.appendChild(panelHintCancelEl);

                this.elParent.appendChild(titleEl);
                this.elParent.appendChild(switcherInnerEl);
                this.elParent.appendChild(panelHintEl);
            }

            this.elParent.removeAttribute('style');
            
            
        }
    }

    /**
     * Create Tag
     * @param elName string;
     */
    createEl(elName, title, className, attrs) {
        const el = document.createElement(elName);
        if(title) el.innerText = title;
        if(className) {
            if ('object' == typeof className) {
                className.forEach((value) => {
                    el.classList.add(value);
                });
            } else {
                el.classList.add(className);
            }
        }
        if(attrs && attrs.length > 0) {
            attrs.forEach(({name, value}) => {
                el.setAttribute(name, value);
            });
        }
        return el;
    }

    /**
     * Save object to storage
     */
    setStorage(obj) {
        localStorage.setItem('zrp-ps', JSON.stringify(obj));
    }

    /**
     * Get object from storage
     */
    getStorage() {
        const store = localStorage.getItem('zrp-ps');

        if (store) {
            return JSON.parse(store);
        }

        return {
            country: null,
            language: null,
        };
    }    

}

document.addEventListener('DOMContentLoaded', ()=>{
    const switcher = new ZrpCountrySwitcher();
    switcher.init();
});